import type { FaireProductEntity } from "../../entity_types/product";

export const p_966f78h4aw: FaireProductEntity = {
  token: "p_966f78h4aw",
  type: "product",
  name: "Ethiopia, Yetatebe Shakisso, 12 oz Organic Single Origin",
  brandToken: "b_3angyj4q6y",
  brandName: "Sightglass Coffee Roasters",
  imageUrl:
    "https://cdn.faire.com/fastly/4884cc41078328573785c5049d1e0f2bdaa1bb0a533a440104e302b956fd2063.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/27154b59604fba20462dd552b73efe014661165006bc03a91f340749fa2c0737.png",
    "https://cdn.faire.com/fastly/b82b58d129f78ef934797c027142575053e449026c4f9295fb856d7491b635ba.png",
    "https://cdn.faire.com/fastly/9ccf66ccd4b10f0cd7dd2ce43179cc5dd5c882b40a89225c905ea3b3dc126352.jpeg",
    "https://cdn.faire.com/fastly/443a70ba743c00b079f7e372b3cc355b79a72c0c0266c0829510f4a5b1cf40d5.jpeg",
    "https://cdn.faire.com/fastly/e136cb9c51e8bf15ed806bbf4ecc8f46f7650e750620a3d644182d77c7023bf9.jpeg",
  ],
  priceDollars: 12.15,
  description:
    'Ethiopia, Yetatebe // This fully-washed coffee ("yetatebe" meaning "washed" in Amharic) comes to us from the Guji highlands. Many of the heirloom varieties that grow wild in and around the highlands of southern Ethiopia are some of the finest and most sought after coffees on the planet.\n\nWhen Sightglass began sourcing this coffee over ten years ago, it was the very first washed coffee that the estate had produced, and it consistently showcases a complexity of flavors and acidity.\n\n• CCOF Certified Organic\n\n• Taste Notes // Jasmine, Bergamot, Lemon Custard\n• Roast Profile // Light-Medium\n• Recommended Brew Methods // V60, Chemex, Kalita Wave, Cold Brew\n• Shelf Life // All our whole bean coffees are roasted fresh to order and stamped with the roast date. We encourage selling the coffee within 60 days of the printed date for optimal freshness and flavor. If you have questions about freshness or how to brew this coffee, send us a note on here or email [redacted-email]!',
  tags: [],
  msrpDollars: 20,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-12T22:02:10.767Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
